import * as React from "react";
import { JSX } from "react/jsx-runtime";
const MapList = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_643_4980)">
      <g clipPath="url(#clip1_643_4980)">
        <path
          d="M3.07505 0.875H1.50005C0.925049 0.875 0.425049 1.35 0.425049 1.95V3.525C0.425049 4.1 0.900049 4.6 1.50005 4.6H3.07505C3.65005 4.6 4.15005 4.125 4.15005 3.525V1.925C4.12505 1.35 3.65005 0.875 3.07505 0.875ZM3.00005 3.45H1.57505V2H3.00005V3.45Z"
         fill="#004E9B"
        />
        <path
          d="M6.4251 3.2999H15.0001C15.3001 3.2999 15.5751 3.0499 15.5751 2.7249C15.5751 2.3999 15.3251 2.1499 15.0001 2.1499H6.4251C6.1251 2.1499 5.8501 2.3999 5.8501 2.7249C5.8501 3.0499 6.1251 3.2999 6.4251 3.2999Z"
         fill="#004E9B"
        />
        <path
          d="M3.07505 6H1.50005C0.925049 6 0.425049 6.475 0.425049 7.075V8.65C0.425049 9.225 0.900049 9.725 1.50005 9.725H3.07505C3.65005 9.725 4.15005 9.25 4.15005 8.65V7.075C4.12505 6.475 3.65005 6 3.07505 6ZM3.00005 8.575H1.57505V7.125H3.00005V8.575Z"
         fill="#004E9B"
        />
        <path
          d="M15.0001 7.2998H6.4251C6.1251 7.2998 5.8501 7.5498 5.8501 7.8748C5.8501 8.1998 6.1001 8.4248 6.4251 8.4248H15.0001C15.3001 8.4248 15.5751 8.1748 15.5751 7.8748C15.5751 7.5748 15.3001 7.2998 15.0001 7.2998Z"
         fill="#004E9B"
        />
        <path
          d="M3.07505 11.4248H1.50005C0.925049 11.4248 0.425049 11.8998 0.425049 12.4998V14.0748C0.425049 14.6498 0.900049 15.1498 1.50005 15.1498H3.07505C3.65005 15.1498 4.15005 14.6748 4.15005 14.0748V12.4998C4.12505 11.8998 3.65005 11.4248 3.07505 11.4248ZM3.00005 13.9998H1.57505V12.5498H3.00005V13.9998Z"
         fill="#004E9B"
        />
        <path
          d="M15.0001 12.7002H6.4251C6.1251 12.7002 5.8501 12.9502 5.8501 13.2752C5.8501 13.6002 6.1001 13.8502 6.4251 13.8502H15.0001C15.3001 13.8502 15.5751 13.6002 15.5751 13.2752C15.5751 12.9502 15.3001 12.7002 15.0001 12.7002Z"
        
          fill="#004E9B"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_643_4980">
        <rect width={16} height={16} fill="white" />
      </clipPath>
      <clipPath id="clip1_643_4980">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MapList;
